import './custom-advanced-marker.css';

import type { FunctionComponent } from 'react';

import { useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import Kamp from 'src/assets/images/activity-icons/Kamp.png';
import Muze from 'src/assets/images/activity-icons/Muze.png';
import Park from 'src/assets/images/activity-icons/Park.png';
import Bakici from 'src/assets/images/activity-icons/Bakici.png';
import Doktor from 'src/assets/images/activity-icons/Doktor.png';
import Default from 'src/assets/images/activity-icons/Default.png';
import Gosteri from 'src/assets/images/activity-icons/Gosteri.png';
import Kurslar from 'src/assets/images/activity-icons/Kurslar.png';
import Anaokulu from 'src/assets/images/activity-icons/Anaokulu.png';
import Atolyeler from 'src/assets/images/activity-icons/Atolyeler.png';
import Tiyatrolar from 'src/assets/images/activity-icons/Tiyatrolar.png';
import Akvaryumlar from 'src/assets/images/activity-icons/Akvaryumlar.png';
import KapaliMekan from 'src/assets/images/activity-icons/KapaliMekan.png';
import OzelDersler from 'src/assets/images/activity-icons/OzelDersler.png';
import SuHavuzlari from 'src/assets/images/activity-icons/SuHavuzlari.png';
import Kutuphaneler from 'src/assets/images/activity-icons/Kutuphaneler.png';
import CafeRestoranlar from 'src/assets/images/activity-icons/CafeRestoranlar.png';
import GezilecekYerler from 'src/assets/images/activity-icons/GezilecekYerler.png';

import { RealEstateIcon } from '../../icons/real-estate-icon';
import { RealEstateGallery } from '../real-estate-gallery/real-estate-gallery';
import { RealEstateListingDetails } from '../real-estate-listing-details/real-estate-listing-details';

import type { RealEstateListing } from '../../types/types';

interface Props {
  activity: any;
  openMarkerId: string | null;
  setOpenMarkerId: React.Dispatch<React.SetStateAction<string | null>>;
}

export const CustomAdvancedMarker: FunctionComponent<Props> = ({
  activity,
  openMarkerId,
  setOpenMarkerId,
}) => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const isMarkerOpen = openMarkerId === (activity._id || activity.id);

  // Koordinatları kontrol et ve number tipine çevir
  const lat = Number(activity.location?.lat);
  const lng = Number(activity.location?.long);

  // Geçerli koordinatları kontrol et
  const hasValidCoordinates =
    !isNaN(lat) &&
    !isNaN(lng) &&
    lat !== 0 &&
    lng !== 0 &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180;

  // Geçerli koordinatlar yoksa marker'ı render etme
  if (!hasValidCoordinates) {
    return null;
  }

  const position = {
    lat,
    lng,
  };

  const handleNavigate = () => {
    // Activity tipini kontrol et - blog mu aktivite mi?
    if (activity.isBlog) {
      navigate(`/blog/${activity._id}`);
    } else {
      navigate(`/aktivite/${activity._id}`);
    }
  };

  const renderCustomPin = () => (
    <div className={`custom-pin ${isMarkerOpen ? 'opened' : ''}`}>
      {!isMarkerOpen ? (
        <img
          src={
            activity.listing?.category?.[0] === 'Mahalle Parkları'
              ? Park
              : activity.listing?.category?.[0] === 'Özel Dersler'
                ? OzelDersler
                : activity.listing?.category?.[0] === 'Gösteriler'
                  ? Gosteri
                  : activity.listing?.category?.[0] ===
                      'Çocuklarla Gidilebilecek Cafe ve Restoranlar'
                    ? CafeRestoranlar
                    : activity.listing?.category?.[0] === 'Akvaryumlar'
                      ? Akvaryumlar
                      : activity.listing?.category?.[0] === 'Çocuk Kitapevleri'
                        ? Kutuphaneler
                        : activity.listing?.category?.[0] === 'Kapalı Mekan Oyun alanları'
                          ? KapaliMekan
                          : activity.listing?.category?.[0] === 'Kış Kampları'
                            ? Default
                            : activity.listing?.category?.[0] === 'Piknik alanları'
                              ? Default
                              : activity.listing?.category?.[0] === 'Kurslar'
                                ? Kurslar
                                : activity.listing?.category?.[0] === 'Çocuk Doktorları'
                                  ? Doktor
                                  : activity.listing?.category?.[0] === 'Etkinlikler'
                                    ? Gosteri
                                    : activity.listing?.category?.[0] === 'Gezilecek Yerler'
                                      ? GezilecekYerler
                                      : activity.listing?.category?.[0] === 'Macera Parkurları'
                                        ? Park
                                        : activity.listing?.category?.[0] === 'Su Havuzları'
                                          ? SuHavuzlari
                                          : activity.listing?.category?.[0] === 'Atölyeler'
                                            ? Atolyeler
                                            : activity.listing?.category?.[0] === 'Evde Etkinlik'
                                              ? Default
                                              : activity.listing?.category?.[0] ===
                                                  'Çocuk Tiyatroları'
                                                ? Tiyatrolar
                                                : activity.listing?.category?.[0] === 'Tiyatrolar'
                                                  ? Tiyatrolar
                                                  : activity.listing?.category?.[0] === 'Kamplar'
                                                    ? Kamp
                                                    : activity.listing?.category?.[0] ===
                                                        'Çocuklarla Gezilecek Tarihi Mekanlar'
                                                      ? Muze
                                                      : activity.listing?.category?.[0] ===
                                                          'Tarihi Mekanlar'
                                                        ? Muze
                                                        : activity.listing?.category?.[0] ===
                                                            'Bakıcılar'
                                                          ? Bakici
                                                          : activity.listing?.category?.[0] ===
                                                              'Bebek Bakıcısı'
                                                            ? Bakici
                                                            : activity.listing?.category?.[0] ===
                                                                'En Çok Tavsiye Edilen Çocuk Dergileri'
                                                              ? Default
                                                              : activity.listing?.category?.[0] ===
                                                                  'Müzeler'
                                                                ? Muze
                                                                : activity.listing
                                                                      ?.category?.[0] ===
                                                                    'Çocuklarla Gidilebilecek Müzeler'
                                                                  ? Muze
                                                                  : activity.listing
                                                                        ?.category?.[0] ===
                                                                      'Kütüphaneler'
                                                                    ? Kutuphaneler
                                                                    : activity.listing
                                                                          ?.category?.[0] ===
                                                                        'Anaokulu ve kreşler'
                                                                      ? Anaokulu
                                                                      : activity.listing
                                                                            ?.category?.[0] ===
                                                                          'Oyun Terapisti/Psikologlar'
                                                                        ? Doktor
                                                                        : activity.listing
                                                                              ?.category?.[0] ===
                                                                            'Çocuk Berberleri'
                                                                          ? Bakici
                                                                          : activity.listing
                                                                                ?.category?.[0] ===
                                                                              'Cafe ve Restoranlar'
                                                                            ? CafeRestoranlar
                                                                            : Default
          }
          alt="marker"
          className="marker-icon"
          width={50}
        />
      ) : (
        <>
          <button
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              setOpenMarkerId(null);
            }}
          >
            <span className="material-symbols-outlined">close</span>
          </button>

          <div className="details-content" onClick={handleNavigate}>
            <RealEstateGallery
              images={
                activity.listing ? [activity.listing.coverImage, ...activity.listing.images] : []
              }
              isExtended={isMarkerOpen}
            />
            <RealEstateListingDetails
              details={{
                listing_title: activity.listing?.title || '',
                listing_description: activity.listing?.description || '',
                property_address: [
                  activity.location?.district,
                  activity.location?.address?.description,
                  activity.location?.district,
                  activity.location?.city,
                ]
                  .filter(Boolean)
                  .join(', '),
                property_price: activity?.price,
                property_square_feet: 'N/A',
              }}
            />
          </div>
        </>
      )}
    </div>
  );

  return (
    <AdvancedMarker
      position={position}
      title={activity.listing?.title}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={classNames('real-estate-marker', {
        clicked: isMarkerOpen,
        hovered,
      })}
      onClick={() =>
        isMarkerOpen ? setOpenMarkerId(null) : setOpenMarkerId(activity._id || activity.id)
      }
    >
      {renderCustomPin()}
    </AdvancedMarker>
  );
};
